import React from "react";
import "./LoginForm.css";
import BrandlyLogo from "../../assets/BrandlyLogo.png";
import LinkedInIcon from "../../assets/LinkedInIcon.png";

const LoginForm = () => {
  const API_URL = process.env.REACT_APP_API_URL;
  const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL;
  const handleLinkedInLogin = () => {
    const redirectUrl = `${FRONTEND_URL}/dashboard`; // 👈 Where user lands after login
    window.location.href = `${API_URL}/auth/login?redirect_url=${encodeURIComponent(
      redirectUrl
    )}`;
  };

  return (
    <div className="login-form-container">
      {/* Logo */}
      <img src={BrandlyLogo} alt="Brandly Logo" className="login-form-logo" />

      {/* Login text */}
      <p className="login-form-text">
        Login to your <span className="login-form-highlight">Account</span>
      </p>

      {/* Continue with LinkedIn Button */}
      <button className="login-form-button" onClick={handleLinkedInLogin}>
        <img
          src={LinkedInIcon}
          alt="LinkedIn Icon"
          className="login-form-icon"
        />
        Continue with LinkedIn
      </button>
    </div>
  );
};

export default LoginForm;
